import { Seo, breadcrumbJsonLd, faqJsonLd } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { FAQSection } from "@/sections/FAQSection";
import { ContactSection } from "@/sections/ContactSection";
import { FAQS } from "@/data/content";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Veelgestelde vragen", path: "/veelgestelde-vragen" },
];

export default function FAQPage() {
  return (
    <>
      <Seo
        title="Veelgestelde vragen thermische branddetectie"
        description="Antwoorden op veelgestelde vragen over thermische camera's, detectiemogelijkheden, alarmgrenzen, onderhoud en kosten voor recyclingbedrijven."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB), faqJsonLd(FAQS)]}
      />
      <PageHeader
        overline="Kennisbank"
        title="Veelgestelde vragen"
        intro="Alles over de werking, mogelijkheden en beperkingen van thermische branddetectie binnen de recyclingsector."
        breadcrumb={BREADCRUMB}
      />
      <FAQSection />
      <ContactSection />
    </>
  );
}
